<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/a124GN/tc-custom/9781526790064.jpg?1729185338518" alt="This image is the cover for the book Yearbook of Astronomy 2022"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Yearbook of Astronomy 2022
      </h1>
      <p class="bookDescription body article font2">
        <b>The “excellent resource” used by both amateur and professional astronomers for sixty years, filled with references and enlightening articles (<i>Booklist</i>).</b><br/>  <br/> Since this invaluable annual publication first appeared in 1962, stargazers and sky-watchers have enjoyed its comprehensive, jargon-free monthly sky notes and its authoritative set of sky charts that enable backyard astronomers everywhere to plan their viewing of the year’s eclipses, comets, meteor showers, and minor planets, as well as detailing the phases of the moon and visibility and locations of the planets throughout the year.<br/>  <br/> It also includes a variety of entertaining and informative articles. In the 2022 edition, you’ll find coverage of a wide range of topics including:<br/>    A History of the Amateur Astronomical Society: 1962 to 2022  Expanding Cosmic Horizons  Frank Drake and His Equation  Remote Telescopes  Skies Over Ancient America, and more   <br/> After six decades, <i>The Yearbook of Astronomy</i> continues to be essential reading for anyone fascinated by the magic and mysteries of our universe. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian Jones
      </h2>
      
      <p class="authorDescription body article">Brian Jones hails from Bradford in the West Riding of Yorkshire and was a founder member of the Bradford Astronomical Society. He developed a fascination for astronomy at the age of five when he first saw the stars through a pair of binoculars, and his interest took him into the realms of writing sky guides for local newspapers, appearing on local radio and television, teaching astronomy and space in schools and, in 1985, becoming a full time astronomy and space writer. He has penned 18 books to date which have covered a range of astronomy and space-related topics for both children and adults. His passion for bringing an appreciation of the universe to his readers is reflected in his writing.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      White Owl
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0c2417be